const pointPerMm = 72 / 25.4;
const pageWidth = 210;
const pageHeight = 297;
const minFontSize = 4;
const maxFontSize = 72;
const settingKey = 'extra_settings_field_position';

const mmToPt = (value) => value * pointPerMm;

const toNumber = (value, fallback, max) => {
    const parsed = parseFloat(value);
    if (! isFinite(parsed) || parsed < 0) return fallback;
    return Math.min(parsed, max);
}

const toFontSize = (value, fallback) => {
    const parsed = toNumber(value, fallback, maxFontSize);
    if (parsed < minFontSize) return fallback;
    return parsed;
}

const resolveField = (field, stored) => {
    const saved = stored || {};
    return {
        is_visible: saved.is_visible !== false,
        x: toNumber(saved.x, field.x, pageWidth),
        y: toNumber(saved.y, field.y, pageHeight),
        font_size: toFontSize(saved.font_size, field.font_size)
    };
}

const getPositionedField = (text, position) => {
    return {
        text: text,
        bold: true,
        noWrap: true,
        fontSize: position.font_size,
        absolutePosition: { x: mmToPt(position.x), y: mmToPt(position.y) }
    };
}

export const resolveFieldPosition = (fields, value) => {
    const stored = value || {};
    return fields.reduce((positions, field) => {
        positions[field.key] = resolveField(field, stored[field.key]);
        return positions;
    }, {});
}

export const getActiveFieldPosition = (customizationFields) => {
    if (! customizationFields) return null;
    const setting = customizationFields[settingKey];
    if (! setting || ! setting.is_active || ! setting.value || ! setting.fields) return null;
    return resolveFieldPosition(setting.fields, setting.value);
}

export const getSampleValues = (fields) => {
    return fields.reduce((values, field) => {
        values[field.key] = field.sample;
        return values;
    }, {});
}

export const getPositionedFields = (positions, values) => {
    return Object.keys(positions)
        .filter((key) => positions[key].is_visible && values[key])
        .map((key) => getPositionedField(values[key], positions[key]));
}
